import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInstagram, faTiktok, faXTwitter } from '@/fontawesome'

export default function SocialMediaSection() {

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg p-6 sm:p-8 shadow-md border border-gray-200 dark:border-gray-700">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-12 h-12 bg-purple-100 dark:bg-purple-900/50 rounded-lg flex items-center justify-center">
          <FontAwesomeIcon icon={faXTwitter} className="w-6 h-6 text-purple-600 dark:text-purple-400" />
        </div>
        <div>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
            Social Media
          </h2>
          <p className="text-sm text-gray-500 dark:text-gray-400">
            Folge Sven Bolz auf allen Plattformen
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* X (Twitter) */}
        <div className="bg-gray-50 dark:bg-gray-700/50 rounded-lg p-6 border border-gray-200 dark:border-gray-600">
          <div className="flex flex-col items-center justify-center py-4 px-4">
            <div className="w-14 h-14 bg-black dark:bg-white rounded-full flex items-center justify-center mb-2">
              <FontAwesomeIcon icon={faXTwitter} className="w-7 h-7 text-white dark:text-black" />
            </div>
            <h3 className="font-semibold text-gray-900 dark:text-white mb-2">X (Twitter)</h3>
            <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">@bolz_sven</p>
            <a
              href="https://x.com/bolz_sven"
              target="_blank"
              rel="noopener noreferrer"
              className="px-4 py-2 border-2 border-gray-900 dark:border-gray-100 text-gray-900 dark:text-gray-100 rounded-lg text-sm font-medium hover:bg-gray-900 hover:text-white dark:hover:bg-gray-100 dark:hover:text-gray-900 transition-colors cursor-pointer"
            >
              Profil besuchen
            </a>
          </div>
        </div>

        {/* Instagram */}
        <div className="bg-gray-50 dark:bg-gray-700/50 rounded-lg p-6 border border-gray-200 dark:border-gray-600">
          <div className="flex flex-col items-center justify-center py-4 px-4">
            <div className="w-14 h-14 bg-gradient-to-tr from-yellow-400 via-pink-500 to-purple-600 rounded-full flex items-center justify-center mb-2">
              <FontAwesomeIcon icon={faInstagram} className="w-7 h-7 text-white" />
            </div>
            <h3 className="font-semibold text-gray-900 dark:text-white mb-2">Instagram</h3>
            <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">@svenbolztrading</p>
            <a
              href="https://www.instagram.com/svenbolztrading/"
              target="_blank"
              rel="noopener noreferrer"
              className="px-4 py-2 border-2 border-gray-900 dark:border-gray-100 text-gray-900 dark:text-gray-100 rounded-lg text-sm font-medium hover:bg-gray-900 hover:text-white dark:hover:bg-gray-100 dark:hover:text-gray-900 transition-colors cursor-pointer"
            >
              Profil besuchen
            </a>
          </div>
        </div>

        {/* TikTok */}
        <div className="bg-gray-50 dark:bg-gray-700/50 rounded-lg p-6 border border-gray-200 dark:border-gray-600">
          <div className="flex flex-col items-center justify-center py-4 px-4">
            <div className="w-14 h-14 bg-black rounded-full flex items-center justify-center mb-2">
              <FontAwesomeIcon icon={faTiktok} className="w-7 h-7 text-white" />
            </div>
            <h3 className="font-semibold text-gray-900 dark:text-white mb-2">TikTok</h3>
            <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">@svenbolztrading</p>
            <a
              href="https://www.tiktok.com/@svenbolztrading"
              target="_blank"
              rel="noopener noreferrer"
              className="px-4 py-2 border-2 border-gray-900 dark:border-gray-100 text-gray-900 dark:text-gray-100 rounded-lg text-sm font-medium hover:bg-gray-900 hover:text-white dark:hover:bg-gray-100 dark:hover:text-gray-900 transition-colors cursor-pointer"
            >
              Profil besuchen
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
